/**
 * Hide header on scroll down, show on scroll up.
 * Transparent bar at literal top only; stays transparent while scrolling down until the user
 * scrolls up (or the bar reappears after being hidden) — then the white background applies.
 * Pauses while mega menu or mobile drawer is open.
 */
(function () {
  const header = document.querySelector('.header-wrapper');
  if (!header) return;

  const AT_TOP_THRESHOLD = 8;
  const SCROLL_MIN_BEFORE_HIDE = 64;
  const DELTA_HIDE = 5;
  const DELTA_SHOW = 5;

  let lastScrollY = Math.max(0, window.scrollY);
  let ticking = false;

  function overlaysOpen() {
    if (document.body.classList.contains('header-mega-open')) return true;
    // Open search modal: drop the transparent "at top" state so the beige panel and
    // its (predictive search) results don't render with the hero's white text.
    if (header.querySelector('.header__search details[open]')) return true;
    const mobile = document.getElementById('mobile-menu-container');
    return Boolean(mobile && !mobile.classList.contains('hidden'));
  }

  function apply() {
    const y = Math.max(0, window.scrollY);
    const prev = lastScrollY;

    if (overlaysOpen()) {
      header.classList.remove('header-wrapper--scroll-hidden', 'header-wrapper--at-top');
      lastScrollY = y;
      return;
    }

    if (y <= AT_TOP_THRESHOLD) {
      header.classList.add('header-wrapper--at-top');
      header.classList.remove('header-wrapper--scroll-hidden');
      lastScrollY = y;
      return;
    }

    const delta = y - prev;
    const wasScrollHidden = header.classList.contains('header-wrapper--scroll-hidden');

    /* Transparent bar persists while scrolling down from the top; solid white only after a scroll-up
       (or when the bar comes back after being hidden). */
    if (delta < -DELTA_SHOW) {
      header.classList.remove('header-wrapper--at-top');
    }

    if (y < SCROLL_MIN_BEFORE_HIDE) {
      header.classList.remove('header-wrapper--scroll-hidden');
    } else if (delta > DELTA_HIDE) {
      header.classList.add('header-wrapper--scroll-hidden');
    } else if (delta < -DELTA_SHOW) {
      header.classList.remove('header-wrapper--scroll-hidden');
    }

    const isScrollHidden = header.classList.contains('header-wrapper--scroll-hidden');
    if (wasScrollHidden && !isScrollHidden && y > AT_TOP_THRESHOLD) {
      header.classList.remove('header-wrapper--at-top');
    }

    lastScrollY = y;
  }

  function onScroll() {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(() => {
        apply();
        ticking = false;
      });
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });

  const mobile = document.getElementById('mobile-menu-container');
  if (mobile) {
    new MutationObserver(apply).observe(mobile, { attributes: true, attributeFilter: ['class'] });
  }
  new MutationObserver(apply).observe(document.body, { attributes: true, attributeFilter: ['class'] });

  apply();
})();
